import { useAuth0 } from '@auth0/auth0-react'
import { Alert, Box } from '@mui/material'
import { useMatches } from 'react-router-dom'
import { useGetMe } from '~hooks/queries/me/use-get-me'

export function MissingPoolNotification() {
  const matches = useMatches()
  const { isAuthenticated } = useAuth0()
  const { data: meVt, isLoading } = useGetMe()
  if (isLoading) {
    return <></>
  }

  // @ts-ignore
  const isRouteWithPools = matches.some((match) => match.handle?.withPools)
  const hasPools =
    (meVt?.profitCenterPools && meVt?.profitCenterPools?.length > 0) ||
    (meVt?.activePools && meVt?.activePools.length > 0)

  if (isAuthenticated && isRouteWithPools && !hasPools) {
    return (
      <Box sx={{ p: 2 }}>
        <Alert severity="error">
          Oops! There has been an error getting your pools. Please reload the
          page or try again later.
        </Alert>
      </Box>
    )
  }

  return <></>
}
